
	import {
		Component,
		Prop,
		Vue,
		Watch
	} from "vue-property-decorator";
	import {
		pca
	} from '@/utils/pca';

	@Component({
		name: 'address-select',
	})
	export default class AddressSelect extends Vue {
		@Prop({
			default: []
		}) value!: any;
		@Prop({
			default: false
		}) private showCounty!: false;
		@Prop({
			default: false
		}) private isorderlist: false;
		@Prop({
			default: false
		}) private disabled: false;
		private province = '';
		private city = '';
		private county = '';
		private provincelist = [];
		private citylist = [];
		private countylist = []
		private first = true

		@Watch('value')
		private onChangeValue(val: any) {
			if (this.value.length) {
				// console.log(val)
				this.changeaddress()
				this.first = true
			}
		}

		private mounted() {
			this.first = true
			this.getProvinceList()
			//订单查询无法监听到value
			if(this.isorderlist){
				this.changeaddress()
			}
		}

		private changeaddress(){
			let value = JSON.parse(JSON.stringify(this.value))
			// console.log(value,999)
			this.province = value[0]
			this.city = value[1]
			this.county = value[2] ? value[2] : ''
			if(!this.first) return 
			if(this.city){
				this.getCity()
			}
			if(this.county){
				this.getCounty()
			}
			this.first = false
		}

		// 获取省份列表
		private getProvinceList() {
			this.provincelist = []
			for (let a in pca) {
				for (let p in pca[a]) {
					this.provincelist.push({
						area: a,
						province: p,
						citys: pca[a][p]
					})
				}
			}
		}

		// 获取城市列表
		private getCity() {
				// console.log(this.provincelist)
			this.citylist = [];
			for (let i = 0; i < this.provincelist.length; i++) {
				if (this.provincelist[i].province == this.province) {
					let citys: any = this.provincelist[i].citys;
					for (let j in citys) {
						this.citylist.push({
							province: this.province,
							city: j,
							county: citys[j]
						})
					}
					// this.city = this.citylist[0].city;
					if (this.showCounty && this.city) {
						this.getCounty()
					} else {
						this.$emit('change', [this.province, this.city])
					}
					break;
				}
			}
			// console.log(this.citylist)
		}

		// 获取地区列表
		private getCounty() {
			this.citylist.map((item: any) => {
				if (item.city === this.city) {
					this.countylist = item.county;
					// this.county = item.county[0];
					// console.log(this.city)
					this.$emit('change', [this.province, this.city, this.county])
				}
			})
		}

		// 修改
		private handleChange(event: any, type: string) {
			// console.log(type)
			if (type === 'city' && this.showCounty) {
				// console.log(this.city,event)
				this.county = ''
				this.getCounty()
				this.$emit('change', [this.province, this.city, this.county])
			}else if (type === 'county') {
				this.$emit('change', [this.province, this.city, this.county])
			} else if (type === 'province')  {
				this.city = ''
				this.county = ''
				this.countylist = []
				this.getCity()
				// this.$emit('change', [this.province, this.city])
				this.$emit('change', [this.province, this.city, this.county])
			}
		}
	}
